import React from "react";
import NamedResourceForm from "../../curriculum/components/named-resource-form";
import {cvDepartmentService} from "../../../services/curriculum-resource-service";

const fields = [
    {name: "name", label: "Nome *", col: "col-span-12"},
];

const CvDepartmentForm = () => (
    <NamedResourceForm singularTitle="Departamento" article="o" basePath="/cv/department"
                       queryKey="cv-departments" service={cvDepartmentService} fields={fields}/>
);

export default CvDepartmentForm;
